module.exports = __webpack_public_path__ + "static/img/m_global_slogan_logo@3x.c3d48f3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/m_global_slogan_logo@3x.png
// module id = 6Y+2
// module chunks = 1